/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import { advSearchState } from 'Stores/advSearch';
import companySearchState from 'Stores/companySearch';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import makeApi, { URLS } from 'Utils/apiUtil';
import { userDetail } from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';

import excludeSampleCsvFile from '../../../../assets/csv/sampleIncludeExclude.csv';

const ExcludeCompanyCSV = observer(props => {
  const {
    filterInPage = false,
    setShowFileView,
    currentTab = 'contact',
  } = props;
  const [fileUpload, setFileUpload] = React.useState(true);
  const [showCsvFileError, setshowCsvFileError] = React.useState('');

  let currentSelectedState;
  if (currentTab === 'contact')
    if (filterInPage) {
      currentSelectedState = advSearchState;
    } else {
      currentSelectedState = advSearchFilterPopupState;
    }
  else currentSelectedState = companySearchState;

  const askUserToPerformSearch = (data, totalDomains) => {
    const okCallback = () => {
      const mxDataMap = {};

      if (currentTab === 'contact')
        if (filterInPage) mxDataMap.filterPlace = 'page';
        else mxDataMap.filterPlace = 'popup';
      else mxDataMap.filterPlace = 'page';
      mxDataMap.currentTab = currentTab;

      const { isFreeTrial } = userDetail;
      mxDataMap.isFreeTrial = isFreeTrial;
      mxDataMap.searchValue = data;

      Utils.mixpanelTrack(
        CONSTANTS.MX_AS_EVENTS.LB_AS_EXCLUDE_COMPANY_SEARCH_PERFORMED,
        mxDataMap,
      );
      currentSelectedState.setUploadCsv('excludedDomains', data);
    };
    const content = `
      Total entries in the file: <b>${totalDomains}</b> <br/>
      Number of valid domains:  <b>${data.domains.length}</b> <br/>
    `;
    confirmationPopupState.setPopupValues({
      title: 'Exclude Companies',
      content,
      actionBtnText: 'Ok',
      callback: okCallback,
      customClassName: 'valid-domains-popup',
    });
    confirmationPopupState.setCustomStyling({
      commonPopupIndex: 113,
      commonPopupMaskIndex: 112,
    });
    confirmationPopupState.setShowPopup(true);
  };

  const validateDomains = res => {
    const data = res;
    if (data && data.domains)
      if (data.domains.length > 0) {
        const totalDomains = data.domains.length;
        const config = {
          url: URLS.getValidDomains,
          method: 'POST',
          data: { domains: data.domains },
        };

        makeApi(config)
          .then(response => {
            if (
              response &&
              response.status === 200 &&
              response.data !== undefined
            ) {
              data.domains = response.data;
              askUserToPerformSearch(data, totalDomains);
            }
          })
          .catch(error => {
            console.log('getValidDomains error ', error);
          });
      } else {
        console.log('domians not found');
      }
  };

  const showErrorAndClear = (value = '') => {
    setshowCsvFileError(value);
    setTimeout(function() {
      setshowCsvFileError('');
    }, 4000);
  };

  const onFileChange = async e => {
    const callBack = callbackData => {
      const data = { domains: callbackData.entries, fname: callbackData.fname };
      if (!callbackData) {
        console.log('empty file', callbackData);
        if (setShowFileView !== undefined) setShowFileView('exclude');
        showErrorAndClear(
          'CSV file is empty, please upload a csv with domains.',
        );
      } else if (callbackData !== '' && callbackData === 'error') {
        console.log('max length error', callbackData);
        if (setShowFileView !== undefined) setShowFileView('exclude');
        showErrorAndClear(
          `CSV not uploaded, please upload a csv with less than ${Utils.getExcludeCompanyDomainSize()} domains.`,
        );
      } else {
        console.log('data ', callbackData);
        validateDomains(data);
      }
      setTimeout(function() {
        setFileUpload(false);
      }, 0);
      setTimeout(function() {
        setFileUpload(true);
      }, 50);
    };
    Utils.uploadCsv(e, callBack, true, Utils.getExcludeCompanyDomainSize());
    // event.target.value = '';
  };

  const triggerUpload = e => {
    setshowCsvFileError('');
    // eslint-disable-next-line no-undef
    document.getElementById('excludeCsv').click();
    if (setShowFileView !== undefined) setShowFileView('');
  };
  console.log('exclusde file render');

  return fileUpload ? (
    <div className="input-section upload-csv">
      {filterInPage ? (
        <div className="upload-csv-label">
          Exclude Companies
          <span className="normal-text">
            {' '}
            (Upload CSV -{' '}
            <a className="sample-csv" href={excludeSampleCsvFile} download="">
              Sample
            </a>
            )
          </span>
          <span
            className="csvupload-info-icon"
            title={`Supports only ${Utils.getExcludeCompanyDomainSize()} companies`}
          >
            <i className="fa fa-info-circle" />
          </span>
        </div>
      ) : (
        <div className="upload-csv-label">
          <div className="text-msg">
            Exclude contacts from companies by uploading list company names or
            websites.
          </div>
          <div className="">
            <span className="normal-text">
              Upload CSV -{' '}
              <a className="sample-csv" href={excludeSampleCsvFile} download="">
                Sample
              </a>
            </span>
          </div>
        </div>
      )}
      <input
        id="excludeCsv"
        className="custom-file-input"
        type="file"
        placeholder=""
        accept=".csv"
        onChange={onFileChange}
        // value={inputVal}
      />
      {showCsvFileError !== '' && (
        <span className="csv-upload-error">{showCsvFileError}</span>
      )}
      <div className="upload-btn" onClick={e => triggerUpload(e)}>
        Choose a file
      </div>
    </div>
  ) : (
    ''
  );
});

export { ExcludeCompanyCSV };
export default ExcludeCompanyCSV;
